import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { LanguageProvider } from './i18n/language-context';
import './i18n/i18n';
import { AppRoutes } from './routes/app-routes';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60 * 1000,
      retry: 0,
      refetchOnWindowFocus: false,
    },
  },
});

/**
 * A single catch-all data route hosting the existing `<Routes>` tree. This gives us
 * `useBlocker` (needed for the unsaved-changes navigation guard) without touching the
 * route definitions themselves — `element` mounts once and re-renders per URL, same as
 * the plain `<BrowserRouter>` it replaces.
 */
const router = createBrowserRouter([
  {
    path: '*',
    element: (
      <QueryClientProvider client={queryClient}>
        <LanguageProvider defaultLanguage="en-US" defaultModules={['common', 'auth']}>
          <AppRoutes />
        </LanguageProvider>
      </QueryClientProvider>
    ),
  },
]);

export default function App() {
  return <RouterProvider router={router} />;
}
